export default "__VITE_ASSET__CFgR3Gc___"